import * as React from 'react';

export const Select = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    <select
      className={`flex items-center justify-center rounded border border-input bg-background text-xs ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-70 cursor-pointer hover:bg-accent ${className || ''}`}
      ref={ref}
      {...props}
    >
      {children}
    </select>
  );
});
Select.displayName = 'Select';
